import { atom } from "recoil";
import { UserModule } from "src/models/user.model";

export const roleModules = atom<UserModule[]>({
  key: "roleModules",
  default: [],
});
